import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

const DefaultBuyoutDays = 90;
const DefaultLeaseTermMonths = 12;

export interface AuthTokenReturn {
  status: string;
  authToken: string;
  parentStoreId?: number;
  settings: {
    displayName: string;
    ui: Record<string, unknown> & CustomUIConfig;
    logoUrl?: string;
    disableCobranding: boolean;
    minLeaseAmount?: number;
    nonLeasableLimit?: number;
    leaseProhibitedInStates: string[];
    overrideLeaseTermMonths: number;
    overrideBuyoutDays: number;
    features?: {
      CheckoutAvsFlow?: boolean;
    };
  };
}

export const getAuthorizationToken = async (key: string): Promise<AuthTokenReturn | undefined> => {
  const endpoint = ENDPOINT.Authorize;

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify({
      key,
      domain: window.location.href,
    }),
  });

  const resp = (await response.json()) as AuthTokenReturn;

  resp.settings.overrideBuyoutDays = resp.settings.overrideBuyoutDays ?? DefaultBuyoutDays;
  resp.settings.overrideLeaseTermMonths = resp.settings.overrideLeaseTermMonths ?? DefaultLeaseTermMonths;

  return response.ok && resp.status === 'AUTH_SUCCESS' ? resp : void 0;
};
